module.exports = __webpack_public_path__ + "img/logo-e.b69f06c0.svg";